import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import styles from "./Footer.module.scss";
import light_logo from "../../assets/images/site-logo/logo_light.svg";
import faceb from "../../assets/images/footer/icons/facebook.svg";
import insta from "../../assets/images/footer/icons/insta.svg";
import ios from "../../assets/images/qr/iOS.svg";
import android from "../../assets/images/qr/android.svg";
import wp from "../../assets/images/footer/icons/whatsapp.svg";
import phone_footer from "../../assets/images/footer/icons/phone_footer.svg";
import email_footer from "../../assets/images/footer/icons/email_footer.svg";
import location_footer from "../../assets/images/footer/icons/location_footer.svg";
import HomeServices from "../../pages/home/homeService/HomeService";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import FooterService from "./footerServices/FooterServices";
import tiktokIcon from "../../assets/images/footer/icons/tiktok.svg";
import { Modal } from "antd";
import { useSubscribe } from "../../hooks/useFooterMutations";
import { ApiCategory } from "../../layouts/Header/types/types";
import { useHeaderCategories } from "../../hooks/useHomeQueries";
import HeaderProductCategories from "../../layouts/Header/headerServices/HeaderServices";
interface Partner {
  id: number;
  name: string;
  logo: string;
}
export interface SocialItem {
  id: number;
  key: string;
  value: string;
}

const Footer = () => {
  const theme = useSelector((state: RootState) => state.theme.mode);
  const reduxSocial = useSelector(
    (state: RootState) => state.socialAccounts
  );
  const socialAccounts = reduxSocial.data || [];
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const selectedLanguage = useSelector(
    (state: RootState) => state.language.selectedLanguage,
  );
  const location = useLocation();

  const { data: headerCategoriesData } = useHeaderCategories(selectedLanguage?.code || "az");
  const categories: ApiCategory[] = useMemo(() => {
    if (Array.isArray(headerCategoriesData)) return headerCategoriesData as ApiCategory[];
    return [];
  }, [headerCategoriesData]);


  // TanStack Query mutation

  const subscribeMutation = useSubscribe();

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const res = await HomeServices.AllPartners();
    //     setAllPartners(res.partners);
    //   } catch (error) { }
    // };
    // fetchData();
  }, []);
  // Redux social accounts used directly (no duplicate network call)
  const translations = useSelector(
    (state: RootState) => state.translations.data
  );
  const footer_links = [
    {
      category: translations?.informations,
      items: [
        {
          name: translations?.blog,
          path: "blog",
        },
        {
          name: translations?.campaigns,
          path: "campaigns",
        },
        // {
        //   name: translations?.news,
        //   path: "/news",
        // },
        {
          name: translations?.videoTutorials,
          path: "videoTutorials",
        },
      ],
    },
    {
      category: translations?.services,
      items: [
        {
          name: translations?.services,
          path: "services",
        },
        {
          name: translations?.apply,
          path: "applyService",
        },
        {
          name: translations?.warrantyTerms,
          path: "warrantyTerms",
        },
        {
          name: translations?.shipping_terms || translations?.delivery_terms || "Daşınma şərtləri",
          path: "dasinma-sertleri",
        },
      ],
    },
    {
      category: "BSC",
      items: [
        {
          name: translations?.contact,
          path: "/contact",
        },
        {
          name: translations?.about_us,
          path: "about",
        },
        {
          name: translations?.career,
          path: "career",
        },
        {
          name: translations?.privacy_policy,
          path: "privacy-policy",
        },
      ],
    },
  ];

  const activeWhatsapp =
    reduxSocial.whatsapp ||
    socialAccounts.find((item: any) =>
      item.key?.toLowerCase().includes("whatsap")
    )?.value ||
    "";

  const activeInstagram =
    reduxSocial.instagram ||
    socialAccounts.find((item: any) =>
      item.key?.toLowerCase().includes("instagram")
    )?.value ||
    "";

  const activeFacebook =
    reduxSocial.facebook ||
    socialAccounts.find((item: any) =>
      item.key?.toLowerCase().includes("facebook")
    )?.value ||
    "";

  const activeTiktok =
    reduxSocial.tiktok ||
    socialAccounts.find((item: any) =>
      item.key?.toLowerCase().includes("tiktok")
    )?.value ||
    "";

  const activePhone =
    reduxSocial.phone ||
    socialAccounts.find(
      (item: any) =>
        item.key?.toLowerCase().includes("phone") ||
        item.key?.toLowerCase().includes("tel") ||
        item.key?.toLowerCase().includes("number")
    )?.value ||
    "";

  const activeEmail =
    reduxSocial.email ||
    socialAccounts.find(
      (item: any) =>
        item.key?.toLowerCase().includes("email") ||
        item.key?.toLowerCase().includes("mail")
    )?.value ||
    "";

  const activeAddress =
    reduxSocial.address ||
    socialAccounts.find(
      (item: any) =>
        item.key?.toLowerCase().includes("address") ||
        item.key?.toLowerCase().includes("ünvan") ||
        item.key?.toLowerCase().includes("unvan") ||
        item.key?.toLowerCase().includes("location")
    )?.value ||
    "";

  // Email validasiyası
  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Subscribe form submit handler
  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setEmailError("");

    // TanStack Query mutation istifadə et
    subscribeMutation.mutate(email.trim(), {
      onSuccess: (response) => {
        if (response.status === 200 || response.status === 201) {
          Modal.success({
            title: translations?.success || "Uğurlu",
            content: translations?.subscribe_success || "Abunə oldunuz!",
            okText: translations?.okay || "Tamam",
          });
          setEmail("");
        }
      },
      onError: (error: any) => {
        if (error.response && error.response.status === 422) {
          const backendErrors = error.response.data.errors;
          if (backendErrors.email) {
            setEmailError(backendErrors.email[0]);
          } else {
            setEmailError(translations?.error || "Xəta baş verdi");
          }
        } else {
          Modal.error({
            title: translations?.error || "Xəta",
            content:
              translations?.subscribe_error || "Abunə olarkən xəta baş verdi",
            okText: translations?.okay || "Tamam",
          });
        }
      },
    });
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (emailError) {
      setEmailError("");
    }
  };

  return (
    <footer id={styles.footer}>
      {/* {location.pathname === "/" && (
        <div className={styles.partners_section}>
          <div className="container">
            <div className={styles.our_partners}>
              <div className={styles.content}>
                <h1 className={styles.partners_title}>
                  {translations.dear_partners}
                </h1>
                <p className={styles.partners_subtitle}>
                  {translations.text_for_partners}
                </p>
              </div>
              <div className={styles.partners}>
                {allPartners.length === 0 ? (
                  // Skeleton state to reserve space
                  <div className={styles.partners_skeleton}>
                    <div className={styles.spare_partners}>
                      {[1, 2, 3].map((i) => (
                        <div key={i} className={styles.partner_card_skeleton} />
                      ))}
                    </div>
                    <div className={styles.spare_partners}>
                      {[1, 2].map((i) => (
                        <div key={i} className={styles.partner_card_skeleton} />
                      ))}
                    </div>
                  </div>
                ) : (
                  <>
                    <div className={styles.spare_partners}>
                      {allPartners.map(
                        (partner: any, index: number) =>
                          index % 2 === 0 && (
                            <div key={index} className={styles.partner_card}>
                              <img
                                src={partner.logo}
                                alt={`partner-${index}`}
                                width="160"
                                height="100"
                                loading="lazy"
                              />
                            </div>
                          )
                      )}
                    </div>
                    <div className={styles.spare_partners}>
                      {allPartners.map(
                        (partner: any, index: number) =>
                          index % 2 !== 0 && (
                            <div key={index} className={styles.partner_card}>
                              <img
                                src={partner.logo}
                                alt={`partner-${index}`}
                                width="160"
                                height="100"
                                loading="lazy"
                              />
                            </div>
                          )
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )} */}
      {/* <div className={styles.footer_top}>
        <div className="container">
          <div className={styles.footer_top_content}>
            <div className={styles.subscribe_us}>
              <p className={styles.subscribe_title}>
                {translations.your_partner}
              </p>
              <form
                onSubmit={handleSubscribe}
                className={styles.subscribe_form}
              >
                <div className={styles.input_control}>
                  <input
                    type="email"
                    name="email"
                    id="subscribe-email"
                    placeholder={translations.email}
                    value={email}
                    onChange={handleEmailChange}
                    onInput={(e: any) => {
                      const target = e.target;
                      target.setCustomValidity("");
                      if (target.validity.valueMissing) {
                        target.setCustomValidity(
                          translations?.enter_email || "Zəhmət olmasa doldurun"
                        );
                      } else if (target.validity.typeMismatch) {
                        target.setCustomValidity(
                          translations?.invalid_email || "Zəhmət olmasa düzgün email daxil edin"
                        );
                      }
                    }}
                    onInvalid={(e: any) => {
                      const target = e.target;
                      if (target.validity.valueMissing) {
                        target.setCustomValidity(
                          translations?.enter_email || "Zəhmət olmasa doldurun"
                        );
                      } else {
                        target.setCustomValidity(
                          translations?.invalid_email || "Zəhmət olmasa düzgün email daxil edin"
                        );
                      }
                    }}
                    required
                    disabled={subscribeMutation.isPending}
                  />
                  {emailError && (
                    <span className={styles.error_message}>{emailError}</span>
                  )}
                </div>
                <div className={styles.form_btn}>
                  <Button
                    text={
                      subscribeMutation.isPending
                        ? translations?.loading || "Göndərilir..."
                        : translations.subscribe
                    }
                    className={styles.subscribe_btn}
                    type="submit"
                    disabled={subscribeMutation.isPending}
                  ></Button>
                </div>
              </form>
              {activePhone && (
                <a href={`tel:${activePhone.replace(/\s+/g, "")}`} className={styles.footerPhone}>
                  <img
                    className={styles.phoneIconFooter}
                    src={phone_footer}
                    alt="call"
                    width="44"
                    height="44"
                  />
                  <p
                    className={`${styles.headerPhone_num} ${
                      theme === "dark" ? styles.headerPhone_num_dark : ""
                    }`}
                  >
                    {activePhone}
                  </p>
                </a>
              )}
            </div>
            <div className={styles.footer_navlinks}>
              <div className={styles.category}>
                <h2 className={styles.category_title}>
                  {translations?.informations}
                </h2>
                <ul className={styles.navlinks_lists}>
                  {footer_links
                    .find(
                      (section) =>
                        section.category === translations?.informations
                    )
                    ?.items.map((item, idx) => (
                      <li key={idx} className={styles.nav_item}>
                        <Link className={styles.footer_link} to={item.path}>
                          {item.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
              <div className={styles.category}>
                <h2 className={styles.category_title}>
                  {translations.services}
                </h2>
                <ul className={styles.navlinks_lists}>
                  {footer_links
                    .find(
                      (section) => section.category === translations?.services
                    )
                    ?.items.map((item, idx) => (
                      <li key={idx} className={styles.nav_item}>
                        <Link className={styles.footer_link} to={item.path}>
                          {item.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
              <div className={styles.category}>
                <h2 className={styles.category_title}>Baku Service Company </h2>
                <ul className={styles.navlinks_lists}>
                  {footer_links
                    .find((section) => section.category === "BSC")
                    ?.items.map((item, idx) => (
                      <li key={idx} className={styles.nav_item}>
                        <Link className={styles.footer_link} to={item.path}>
                          {item.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className={styles.footer_bottom}>
        <div className="container">
          <div className={styles.footer_bottom_content}>
            <div className={styles.footer_logo}>
              <Link to="/" aria-label="1412 Ana Səhifə" tabIndex={0}>
                <img src={light_logo} className={styles.mix_shop_logo} alt="1412 logo" width="72" height="49" />
              </Link>
              <p className={styles.footer_tagline}>
                1412 – keyfiyyətli məhsullar, sərfəli qiymətlər və etibarlı xidmət bir arada.
              </p>
              <div className={styles.social_media}>
                {activeFacebook && (
                  <a href={activeFacebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <div className={styles.icon_box}>
                      <img src={faceb} alt="facebook" width="20" height="20" />
                    </div>
                  </a>
                )}
                {activeInstagram && (
                  <a href={activeInstagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <div className={styles.icon_box}>
                      <img src={insta} alt="instagram" width="20" height="20" />
                    </div>
                  </a>
                )}
                {activeTiktok && (
                  <a href={activeTiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                    <div className={styles.icon_box}>
                      <img src={tiktokIcon} alt="tiktok" width="20" height="20" />
                    </div>
                  </a>
                )}
                {activeWhatsapp && (
                  <a href={activeWhatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                    <div className={styles.icon_box}>
                      <img src={wp} alt="whatsapp" width="20" height="20" />
                    </div>
                  </a>
                )}
              </div>
            </div>
            <div className={styles.smedia_rights}>
              {/* Məlumat bölməsi */}
              <ul className={styles.category__f}>
                <h3>{translations?.about || "Məlumat"}</h3>
                <li>
                  <NavLink
                    to="/about"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                  >
                    {translations?.about_us || "Haqqımızda"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/privacy-policy"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                  >
                    {translations?.privacy_policy || "Məxfilik siyasəti"}
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    to="/career"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                  >
                    {translations?.career || "Karyera"}
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    to="/contact"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                  >
                    {translations?.contact || "Əlaqə"}
                  </NavLink>
                </li>
              </ul>

              {/* Kömək bölməsi */}
              <ul className={styles.category__f}>
                <h3>{translations?.help || "Kömək"}</h3>
                <li>
                  <NavLink
                    to="/warrantyTerms"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                  >
                    {translations?.warrantyTitle || "Zəmanət şərtləri"}
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    to="/campaigns"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                  >
                    {translations?.campaigns || "Kampaniyalar"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                  >
                    {translations?.services || "Xidmətlər"}
                  </NavLink>
                </li> */}
                {/* <li>
                  <NavLink
                    to="/applyService"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                  >
                    {translations?.apply || "Müraciət et"}
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    to="/dasinma-sertleri"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                    tabIndex={0}
                    aria-label={translations?.shipping_terms || translations?.delivery_terms || "Daşınma şərtləri"}
                  >
                    {translations?.shipping_terms || translations?.delivery_terms || "Daşınma şərtləri"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/blog"
                    className={({ isActive }) =>
                      `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                    }
                  >
                    {translations?.blog || "Bloq"}
                  </NavLink>
                </li>
              </ul>

              {/* Kateqoriyalar bölməsi */}
              {/* <ul className={styles.category__f}>
                <h3>{translations?.categories || translations?.products || "Kateqoriyalar"}</h3>
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.id}>
                    <NavLink
                      to={`/products/${cat.id}`}
                      className={({ isActive }) =>
                        `${styles.nav_item} ${isActive ? styles.nav_active : ""}`
                      }
                    >
                      {cat.name}
                    </NavLink>
                  </li>
                ))}
              </ul> */}

              {/* Əlaqə bölməsi */}
              <ul className={styles.category__f}>
                <h3>{translations?.contact || "Əlaqə"}</h3>
                {activePhone && (
                  <li className={styles.contact_item}>
                    <a
                      href={`tel:${activePhone.replace(/\s+/g, "")}`}
                      className={styles.nav_item}
                    >
                      <img src={phone_footer} alt="phone" width="18" height="18" />
                      <span>{activePhone}</span>
                    </a>
                  </li>
                )}
                {activeEmail && (
                  <li className={styles.contact_item}>
                    <a
                      href={`mailto:${activeEmail}`}
                      className={styles.nav_item}
                    >
                      <img src={email_footer} alt="email" width="18" height="18" />
                      <span>{activeEmail}</span>
                    </a>
                  </li>
                )}
                {activeAddress && (
                  <li className={styles.contact_item}>
                    <span className={styles.nav_item}>
                      <img src={location_footer} alt="location" width="18" height="18" />
                      <span>{activeAddress}</span>
                    </span>
                  </li>
                )}
              </ul>


              

            
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

